export const getAllCommissions = () => 'payment/commission-summary/';